<template>
  <v-app>
    <template v-if="showMenuAndFooter">
      <MenuBar />
    </template>
    <template v-if="showMenuLateral">
      <MenuLateral />
    </template>

    <v-main>
      <router-view />
    </v-main>

    <template v-if="showMenuAndFooter">
      <FooterBar />
    </template>
  </v-app>
</template>

<script>
import MenuBar from "./components/MenuBar.vue";
import FooterBar from "./components/FooterBar.vue";
import MenuLateral from "./components/MenuLateral.vue";

export default {
  name: "App",
  components: {
    MenuBar,
    FooterBar,
    MenuLateral
  },
  computed: {
    showMenuAndFooter() {
      const allowedPaths = [
        '/',
        '/sobre',
        '/politica-de-privacidade',
        '/termos-de-uso',
        '/blog',
      ];
      // Verifica caminhos exatos ou se começa com /blog/ (rotas dinâmicas)
      return allowedPaths.includes(this.$route.path) || this.$route.path.startsWith('/blog/');
    },

    showMenuLateral(){
      const allowedPaths = [
        '/',
        '/sobre',
        '/politica-de-privacidade',
        '/termos-de-uso',
        '/cadastro',
        '/login',
        '/blog'
      ];
      
      // Verifica caminhos exatos ou se começa com /blog/ (rotas dinâmicas)
      return !allowedPaths.includes(this.$route.path) && !this.$route.path.startsWith('/blog/');
    }
  },
};
</script>

<style>
  html {
    zoom: 1 !important; /* Chrome, Edge, Safari */
  }

  /* Firefox */
  @-moz-document url-prefix() {
    html {
      transform: scale(0.9);
      transform-origin: top left;
      width: 111.12%;
      overflow-x: hidden;
    }
  }
</style>
